<script setup lang="ts">
import Cookies from 'js-cookie';
import {Divider, Icon, Modal, Sider, Space, Spin, Text} from "view-ui-plus";
import {
  IOIClient, IOIClientConnectStatus, IOIMessage,
  IOIContactManager,
  IOIGroupManager, IOIClientListener,
  IOIChatManager, IOIMessageListener,
  IOIUserInfoManager, IOIMessageLabel
} from 'imio-sdk-lite'
import {User, useUserStore} from "@/stores/user.ts";
import {useRoute, useRouter} from "vue-router";
import {useAppStore} from "@/stores/app.ts";
import {getCurrentInstance, onMounted, onUnmounted, ref} from "vue";
import {refresh} from "@/api/account.ts";
import {showNotification} from "@/plugins/notify.ts";

let userStore = useUserStore();
let router = useRouter();
let route = useRoute();


let appStore = useAppStore();
let instance = getCurrentInstance();
instance?.proxy?.$Message.config({
  top: 50,
  duration: 2.5
})
instance?.proxy?.$Loading.config({
  height: 5,
})
const isPrompt = ref(false)
let prompt = Cookies.get("prompt");
if (!prompt) {
  isPrompt.value = true;
  Cookies.set("prompt", 1);
}
let isVisible = true;
let pub = Cookies.get("pub");
if (!pub) {
  setTimeout(() => {
    appStore.publish = true
  }, 30 * 60 * 1000)
}

if (!userStore.user || !userStore.user.name.length) {
  try {
    let userStr = window.localStorage.getItem("user");
    if (userStr) {
      let parse = JSON.parse(userStr + "");
      userStore.setUser(parse)
    }
  } catch (e) {
  }
}
// console.log("App ======== setup",route.query)
appStore.windowMedia.innerHeight = window.innerWidth + ""
appStore.windowMedia.innerHeight = window.innerHeight + ""
// console.log('innerHeight',appStore.windowMedia.innerHeight)
if (window.innerHeight < 700) {
  appStore.showBar = false;
} else {
  appStore.showBar = true;
}
let resizeListener = (e: any) => {
  appStore.windowMedia.innerHeight = e.target.innerHeight + "";
  appStore.windowMedia.innerWidth = e.target.innerWidth + "";
  if (window.innerHeight < 700) {
    appStore.showBar = false;
  } else {
    appStore.showBar = true;
  }
  // instance?.proxy?.$Message.info("Height:"+e.target.innerHeight)
  // console.log('innerHeight',appStore.windowMedia.innerHeight)
  // console.log('innerWidth',appStore.windowMedia.innerWidth)
};

const handleVisibilityChange = () => {
  isVisible = document.visibilityState === 'visible'

  if (isVisible) {
    // console.log('页面可见')
    // 可在此恢复轮询、动画、定时器等
  } else {
    // console.log('页面不可见')
    // 可在此暂停耗电操作
  }
}

let oyClient = IOIClient.getInstance();
IOIGroupManager.getInstance().setClient(oyClient)
IOIContactManager.getInstance().setClient(oyClient)
IOIChatManager.getInstance().setClient(oyClient)
IOIUserInfoManager.getInstance().setClient(oyClient)

const clientListener = {
  id: 'app',
  onConnectStatus(status: IOIClientConnectStatus, retry: number): void {
    // console.log('onConnectStatus',status,retry);
    if (status == IOIClientConnectStatus.DONE) {
      appStore.linkStatus = ''
    }
    if (status == IOIClientConnectStatus.ERROR) {
      appStore.linkStatus = '连接断开'
    }
    if (status == IOIClientConnectStatus.CONNECTING) {
      appStore.linkStatus = '连接中...'
    }
    if (status == IOIClientConnectStatus.SUCCESS) {
      appStore.linkStatus = '已连接'
    }
    if (status == IOIClientConnectStatus.SUCCESS_PULL) {
      appStore.linkStatus = '已连接'
    }
    if (status == IOIClientConnectStatus.RETRY_CONNECTING) {
      appStore.linkStatus = '连接重试中'
    }
    if (status == IOIClientConnectStatus.TOKEN_EXPIRED) {
      appStore.linkStatus = '连接超时'
    }
  }, onConnected(): void {
    // console.log('onConnected')

  }, onDisconnected(): void {
    // console.log('onDisconnected')
    appStore.linkStatus = '连接关闭'

  }, onTokenExpired(): void {
    appStore.linkStatus = '凭证过期'
    let refreshToken = Cookies.get("refresh");
    if (refreshToken) {
      refresh(refreshToken).then(res => {
        if (res.access_token) {
          // console.log("ws refresh", res.access_token)
          Cookies.set("token", `${res.token_type} ${res.access_token}`)
          oyClient.setToken(res.access_token);
          let jwtPayload = getJwtPayload(res.access_token);
          oyClient.connect(jwtPayload.account, res.access_token, jwtPayload.nickname)
          // console.log("ws resend", jwtPayload.account)
        }
      })
    }
    // console.log('onTokenExpired')
  }
} as IOIClientListener

const messageListener = {
  id: "app",
  onMessage(message: IOIMessage): void {
    console.log('APP handleMessage '+isVisible)
    handleMessage(message)
  }, onNotice(message: IOIMessage): void {
    console.log('App onNotice',message)
    handleNotice(message)
  }, onMessageRead(contactId: number, messageId: string): void {
  }, onMessageRevoke(contactId: number, messageId: string): void {
  }
} as IOIMessageListener;

onMounted(() => {
  oyClient.addMessageListener(messageListener);
  window.addEventListener('resize', resizeListener)
  document.addEventListener('visibilitychange', handleVisibilityChange)
  // let length = oyClient.messageListener.length;
  // console.log("messageListener.length", length)
})
oyClient.clientListener = clientListener
onUnmounted(() => {
  window.removeEventListener('resize', resizeListener)
  document.removeEventListener('visibilitychange', handleVisibilityChange)
})

function getJwtPayload(token: string): Object {
  // 分割JWT的三个部分
  const parts = token.split('.');
  // 解码JWT的第二部分（负载部分）
  const payload = parts[1];
  // 将Base64编码的负载解码回正常字符串
  const decodedPayload = atob(payload);
  // 解析为JSON对象
  return JSON.parse(decodedPayload);
}

function downPublish(i: number) {
  Cookies.set("pub", i);
  if (i == 1) {
    window.open('/release.apk', '_blank')
  } else {
    window.open('/release.zip', '_blank')
  }
}

let contactList = oyClient.contactList;

function handleNotice(message: IOIMessage) {
  try {
    if (message.title.length) {
      instance?.proxy?.$Notice.open({
        title: message.title,
        duration: 3
      })
    }
    if (!isVisible) {

    }
  } catch (e) {
    let title = "通知";
    showNotification(title, {
      body: message.title + "",
      tag: message.messageId+"",
      silent: true
    });
  }
}

function handleMessage(message: IOIMessage) {
  try {
    let dialogList = [];
    let dialogStr = window.localStorage.getItem("dialog");
    if (dialogStr) {
      dialogList = JSON.parse(dialogStr);
    }
    let find = dialogList.find((it: any) => it.joinId == message.joinId);
    let contact = contactList.find((it: any) => it.joinId == message.joinId);
    let text = '';
    switch (message.type) {
      case 'txt':
        text = message.text;
        break;
      case 'img':
        text = '[图片]';
        break;
    }
    if (find) {
      find.joinId = message.joinId;
      find.avatar = contact ? contact.avatar : message.thumb;
      find.nickname = contact ? contact.nickname : message.fromName;
      find.text = text;
      find.sentDate = new Date(message.sent);
      find.tip = find.tip + 1;
    } else {
      let d = {
        joinId: message.joinId,
        avatar: contact ? contact.avatar : message.thumb,
        nickname: contact ? contact.nickname : message.fromName,
        text: text,
        sentDate: new Date(message.sent),
        tip: 1,
      }
      dialogList.push(d);
    }
    let value = JSON.stringify(dialogList);
    window.localStorage.setItem("dialog", value);

  } catch (e) {
  }
  try {
    isVisible = document.visibilityState === 'visible'
    if (!isVisible) {
      let contact = contactList.find((it: any) => it.joinId == message.joinId);
      let title = "";
      if (contact) {
        title = contact.username.length ? contact.username : contact.nickname;
      } else {
        title = message.fromName
      }
      let text = '';
      switch (message.type) {
        case 'txt':
          text = message.text;
          break;
        case 'img':
          text = '[图片]';
          break;
      }
      showNotification(title, {
        body: text,
        tag: message.messageId + "",
        silent: true
      });
    }
  } catch (e) {

  }
}

</script>

<template>
  <div class="app">
    <router-view/>
  </div>
  <Modal v-model="isPrompt" fullscreen title="成人提示" :footer-hide="true" :closable="false">
    <div class="flex flex-direction justify-center align-center">

      <div class=" ivu-mt-16">
        <Title level="2"> 18禁成人提示 </Title>

      </div>

      <div class="card ivu-mt-16 card-but" @click="isPrompt = !isPrompt">
        <p class="flex justify-center align-center"><strong>满18岁，请点此进入 </strong></p>
      </div>
      <div class="card card-but ivu-mt-8" @click="isPrompt = !isPrompt">
        <p class="flex justify-center align-center"><strong> If you are over 18，please click here </strong></p>
      </div>

      <Divider/>

      <div>
        <Title level="4"> 警告 / WARNING </Title>

      </div>
      <div class="ivu-mt-16"><strong>本物品內容可能令人反感；不可將本物品內容派發，傳閱，出售，出租，交給或出借予年齡未滿 18
        歲的人士出示，播放或播映。</strong></div>
      <div class="ivu-mt-16">This article contains material which may offernd and may not be distributed, circulated,
        sold, hired, given, lent, shown, played or projected to a person under the age of 18 years. All models are 18 or
        older.
      </div>

    </div>
  </Modal>


  <Modal v-model="appStore.publish" width="300">
    <template #header>
      <p style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>下载发布器</span>
      </p>
    </template>
    <div style="text-align:center">
      <strong>没有哪个网址是永久的</strong>
      <p>域名和页面即将失效，不再跳转，请尽快下载发布器</p>
    </div>
    <template #footer>
      <Space type="flex">
        <Button type="info" v-if="false" long @click="downPublish(2)">PC发布器</Button>
        <Button type="primary" long @click="downPublish(1)">安卓发布器</Button>
      </Space>
    </template>
  </Modal>

  <Spin fix v-show="appStore.loading">
    <img src="@/assets/image/logo2.png" width="60px" height="60px" class="ivu-anim-loop">
    <div>Loading</div>
  </Spin>


</template>

<style scoped>
.ivu-layout-sider {
  min-width: 0;
  max-width: 30px;
}

.card-but {
  background: #ddd;
  width: 400px;
}

.card-but p {
  font-size: 20px;
}
</style>